import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { DateTimePickerComponent } from './date-time-picker.component';
import { MatLegacyInputModule as MatInputModule } from "@angular/material/legacy-input";
import { DropdownModule } from '../dropdown/dropdown.module';
import { TextboxModule } from '../textbox/textbox.module';
import { NgxMatDatetimePickerModule } from '../../../../third-party-libs/datetime-picker/src';

@NgModule({
    imports: [
        CommonModule,
        ReactiveFormsModule.withConfig({callSetDisabledState: 'whenDisabledForLegacyCode'}),
        FormsModule,
        MatDatepickerModule,
        MatNativeDateModule,
        MatInputModule,
        DropdownModule,
        TextboxModule,
        NgxMatDatetimePickerModule
    ],
    declarations: [
        DateTimePickerComponent
    ],
    exports: [
        DateTimePickerComponent
    ]
})
export class DateTimePickerModule {
}
